<template>
  <div class="h-10 relative placeholder">
    <van-nav-bar
      :title="title"
      left-arrow
      @click-left="handleClickLeft"
      class="h-10"
      safe-area-inset-top
      fixed
    >
      <template #right>
        <slot name="right"></slot>
      </template>
    </van-nav-bar>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
const router = useRouter()
import { useGoBack } from '@/composables/useGoBack'
const { goBack } = useGoBack()

const props = defineProps<{ title: string; onClickLeft?: () => void }>()
const handleClickLeft = () => {
  if (props.onClickLeft) {
    props.onClickLeft()
  } else {
    goBack()
  }
}
</script>
<style scoped lang="less">
.placeholder {
  /deep/ .van-nav-bar__content {
    height: 40px;
  }
}
</style>
